<template>
  <div>
    <div class="background-clouds" v-if="ready" :style="'height:' + height + 'px'">
      <template v-for="(element, key) in generatedElements">
        <component :is="element.element" :style="cloudStyle(element)" :key="key"></component>
      </template>
    </div>
    <div id="component-size-calculator"></div>
  </div>
</template>

<style lang="scss" scoped>
  .background-clouds {
    width: 100%;
    position: relative;
    display: block;
    justify-content: center;
    align-items: center;
    overflow-x: hidden;
    overflow-y: visible;
  }
</style>

<script>
import Vue from 'vue'

export default {
  props: {
    height: {
      required: true
    },
    density: {
      required: false,
      default: 15
    },
    opacity: {
      required: false,
      default: () => {
        return {
          min: 0.4,
          max: 0.7
        }
      }
    },
    scale: {
      required: false,
      default: () => {
        return {
          min: 0.15,
          max: 0.3
        }
      }
    },
    padding: {
      required: false,
      default: 30
    },
    elements: {
      required: true
    }
  },
  data () {
    return {
      heightInPixels: 0,
      widthInPixels: 0,
      maxHeight: 0,
      maxWidth: 0,
      rows: 0,
      cols: 0,
      elementSizes: [],
      generatedElements: [],
      ready: false
    }
  },
  mounted () {
    this.heightInPixels = this.$el.clientHeight
    this.widthInPixels = this.$el.clientWidth
    this.calculateElementSizes()
    this.calculateGrid()
    this.generateElements()
    this.ready = true
  },
  methods: {
    calculateGrid () {
      const rows = Math.floor(this.height / ((this.maxHeight * this.scale.max) + this.padding) - 1)
      const cols = Math.floor(this.widthInPixels / ((this.maxWidth * this.scale.max) + this.padding) - 1)

      this.rows = rows
      this.cols = cols
    },
    generateElements () {
      const stepX = Math.floor(this.widthInPixels / this.cols)
      const stepY = Math.floor(this.height / this.rows)

      for (let x = 0; x < this.cols; x++) {
        const upperX = ((x + 1) * stepX) - (this.maxWidth * this.scale.max)
        const lowerX = (x * stepX)
        for (let y = 0; y < this.rows; y++) {
          const chosen = Math.floor(Math.random() * this.elements.length)

          const upperY = ((y + 1) * stepY) - (this.maxHeight)
          const lowerY = y * stepY

          const chosenX = (Math.floor(Math.random() * (upperX - lowerX + 1)) + lowerX) - (this.maxWidth * this.scale.max)
          const chosenY = (Math.floor(Math.random() * (upperY - lowerY + 1)) + lowerY)

          // Opacity value between min and max configured values
          const opacity = ((Math.random() * (this.opacity.max - this.opacity.min)) + this.opacity.min).toFixed(2)

          // Random scale
          const scale = ((Math.random() * (this.scale.max - this.scale.min)) + this.scale.min).toFixed(2)

          this.generatedElements.push({
            type: chosen,
            element: this.elements[chosen],
            x: chosenX,
            y: chosenY,
            opacity,
            scale
          })
        }
      }
    },
    calculateElementSizes () {
      const calculationElement = document.getElementById('component-size-calculator')
      if (calculationElement) {
        let index = 0
        for (const element of this.elements) {
          const tempElement = document.createElement('div')
          tempElement.setAttribute('id', 'calculate')
          calculationElement.appendChild(tempElement)

          const TempConstructor = Vue.extend(element)
          const tempComponent = new TempConstructor()
          const tempMounted = tempComponent.$mount('#calculate').$el

          this.elementSizes[index] = {
            width: tempMounted.clientWidth,
            height: tempMounted.clientHeight
          }

          if (tempMounted.clientHeight > this.maxHeight) {
            this.maxHeight = tempMounted.clientHeight
          }

          if (tempMounted.clientWidth > this.maxWidth) {
            this.maxWidth = tempMounted.clientWidth
          }

          calculationElement.innerHTML = ''
          index++
        }

        calculationElement.outerHTML = ''
      }
    },
    cloudStyle (element) {
      return `left: ${element.x}px; top: ${element.y}px; opacity: ${element.opacity}; transform: scale(${element.scale}); transform-origin: center center;`
    }
  }
}
</script>
